/** Приводит documentUrl / linkToPdf к пути относительно baseURL filestore. */
export function normalizeFilestorePath(documentPath: string): string {
  if (!documentPath) {
    return documentPath;
  }

  const filestoreInUrl = documentPath.match(/\/filestore(\/api\/v1\/.*)$/);
  if (filestoreInUrl) {
    return filestoreInUrl[1];
  }

  if (documentPath.startsWith("/filestore")) {
    return documentPath.replace(/^\/filestore/, "");
  }

  return documentPath;
}

export function toFilestoreRequestPath(documentPath: string): string {
  const normalized = normalizeFilestorePath(documentPath);

  if (normalized.startsWith("/filestore")) {
    return normalized;
  }

  return `/filestore${normalized.startsWith("/") ? normalized : `/${normalized}`}`;
}

function isExternalDirectUrl(url: string): boolean {
  return (
    url.startsWith("https://storage.") ||
    url.startsWith("http://storage.") ||
    url.includes("yandexcloud.net")
  );
}

export function isFilestoreDocumentPath(url: string): boolean {
  if (!url || url.startsWith("blob:") || isExternalDirectUrl(url)) {
    return false;
  }

  if (url.includes("/filestore/") || url.startsWith("/filestore")) {
    return true;
  }

  const normalized = normalizeFilestorePath(url);

  return (
    normalized.startsWith("/api/v1/") ||
    normalized.startsWith("api/v1/") ||
    (url.startsWith("/") && !url.startsWith("/s3-adapter"))
  );
}
